var re = new RegExp(['^', 'Uncaught\\s', '(.+?)', ':\\s', '(.+)', '$'].join(''));
export function uncaughtMessageFilter(notice) {
  var err = notice.errors[0];
  if (err.type !== '' && err.type !== 'Error') {
    return notice;
  }
  var m = err.message.match(re);
  if (m !== null) {
    err.type = m[1];
    err.message = m[2];
  }
  return notice;
}